import { shareSoundEnabled } from './shareSound';

// A short voiced “ha-ha-ha”, synthesized locally with no audio download.
export function playLaughSound() {
  if (!shareSoundEnabled()) return;
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return;
  let context;
  try {
    context = new AudioContext();
    const laugh = () => {
      const now = context.currentTime;
      [0, .14, .29, .45].forEach((offset, index) => {
        const start = now + offset;
        const voice = context.createOscillator();
        const volume = context.createGain();
        voice.type = 'sawtooth';
        voice.frequency.setValueAtTime(230 - index * 16, start);
        voice.frequency.exponentialRampToValueAtTime(150 - index * 10, start + .11);
        volume.gain.setValueAtTime(.001, start);
        volume.gain.exponentialRampToValueAtTime(.045, start + .025);
        volume.gain.exponentialRampToValueAtTime(.001, start + .12);
        // Parallel vowel formants give each pulse a rounded “ha” timbre.
        [750, 1200].forEach(frequency => {
          const formant = context.createBiquadFilter();
          formant.type = 'bandpass'; formant.frequency.value = frequency; formant.Q.value = 3;
          voice.connect(formant); formant.connect(volume);
        });
        volume.connect(context.destination);
        voice.start(start); voice.stop(start + .13);
        if (index === 3) voice.onended = () => { context.close().catch(() => {}); };
      });
    };
    if (context.state === 'suspended') context.resume().then(laugh).catch(() => context.close().catch(() => {}));
    else laugh();
  } catch { if (context) context.close().catch(() => {}); }
}
